import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FieldService {
  private _inputUpdateNgModelOnBlur = false;
  private _multilineUpdateNgModelOnBlur = false;
  private _selectorResponsiveTemplate = false;
  private _selectorMultipleResponsiveTemplate = false;

  constructor() {
  }

  getInputUpdateNgModelOnBlur(): boolean {
    return this._inputUpdateNgModelOnBlur;
  }

  setInputUpdateNgModelOnBlur(val): void {
    this._inputUpdateNgModelOnBlur = val;
  }

  getMultilineUpdateNgModelOnBlur(): boolean {
    return this._multilineUpdateNgModelOnBlur;
  }

  setMultilineUpdateNgModelOnBlur(val): void {
    this._multilineUpdateNgModelOnBlur = val;
  }

  getSelectorResponsiveTemplate(): boolean {
    return this._selectorResponsiveTemplate;
  }

  setSelectorResponsiveTemplate(val): void {
    this._selectorResponsiveTemplate = val;
  }

  getSelectorMultipleResponsiveTemplate(): boolean {
    return this._selectorMultipleResponsiveTemplate;
  }

  setSelectorMultipleResponsiveTemplate(val): void {
    this._selectorMultipleResponsiveTemplate = val;
  }
}
